
  import moment from 'moment';
  import blogs from '@/apollo/queries/blog/blogs'
  
  export default {
    name: "BlogListing",
    props: {
        tagFilters: {
            type: Array,
            default: () => [],
        },
        authorFilters: {
            type: Array,
            default: () => [],
        },
        blogsDataExternal: {
          type: Array,
          default: () => [],
        }


    },
    computed: {
      blogsComputed() {
        return this.blogsDataExternal.length > 0 ? this.blogsDataExternal : this.blogs 
      }
    },
    data() {
        return {
            blogs: Array,
            page: 1,
            hasMore: true,
        };
    },
    apollo: {
        $loadingKey: "loading",
        blogs: {
            prefetch: true,
            query: blogs,
            variables() {
                const returnObj = {};
                returnObj.currentlocale = this.$normalizeLocale(this.$i18n.locale);
                returnObj.today = moment().format('YYYY-MM-DD');
                returnObj.pagesize = 3; // default is 9?
                if (this.tagFilters.length > 0) {
                    returnObj.cats = this.tagFilters;
                }
                if (this.authorFilters.length > 0) {
                    returnObj.authors = this.authorFilters;
                }
                return returnObj;
            },
            update(data) {
                this.hasMore = data?.blogs?.meta?.pagination?.pageCount > this.page;
                return this.$normalizeStrapi(data.blogs.data);
            },
            result({ data }) {
                // console.info("***apollo blogs data ***");
                // console.debug(JSON.stringify(data));
            },
        }
    },
    methods: {
        showMore() {
            this.page++;
            try {
                this.$apollo.queries.blogs.fetchMore({
                    variables: {
                        page: this.page
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        this.hasMore = fetchMoreResult.blogs.meta.pagination.pageCount > this.page;
                        const newData = [...fetchMoreResult.blogs.data];
                        return {
                            blogs: {
                                __typename: previousResult.blogs.__typename,
                                data: [...previousResult.blogs.data, ...newData],
                                meta: fetchMoreResult.blogs.meta
                            }
                        };
                    }
                });
            }
            catch {
            }
        },
        reloadBlogListing() {
          this.$store.commit('blog/clearTagCodes')
          this.$store.commit('blog/clearAuthorCodes')
        }
    },
}
